import { PagaduriaCondicionHistorico } from './../_models/pagaduria-condicion-historico';
import { AutenticacionService } from './autenticacion.service';
import { AppSettings } from './../../proyect.conf';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PagaduriasCondicionesHistoricosService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/pagaduriasCondicionesHistoricos';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PagaduriaCondicionHistorico[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PagaduriaCondicionHistorico[] ) );
  }

  listadoPorIdPagaduriaCondicion(id : string) {
    return this.httClient.get( this.rutServicio + '/pagaduriaCondicion/' + id ).pipe( map( res => res as PagaduriaCondicionHistorico[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PagaduriaCondicionHistorico ) );
  }

  crear( regCrear: PagaduriaCondicionHistorico ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PagaduriaCondicionHistorico ) );
  }

  actualizar( regActualizar: PagaduriaCondicionHistorico ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
